import React from "react";
import {ICONS} from "./icons-data.js";

/**
 * Version de produccion de Icon: los SVG de Lucide van bundleados en build
 * time (icons-data.js), no se piden por fetch() a unpkg en el navegador.
 * Sin esto, cada carga de icono era un dangerouslySetInnerHTML con contenido
 * de un tercero traido en tiempo real - superficie de XSS innecesaria y una
 * dependencia de CDN en produccion. Misma API que el Icon.jsx del sistema de
 * diseno, para que Shell/HomeScreen/etc no necesiten cambiar.
 */
export function Icon({name,size=18,strokeAlign,style,...rest}){
  const svg=ICONS[name]||"";
  const markup=svg?svg.replace(/width="24"/,'width="100%"').replace(/height="24"/,'height="100%"'):"";
  return (
    <span
      aria-hidden="true"
      dangerouslySetInnerHTML={{__html:markup}}
      style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:size,height:size,flex:"0 0 auto",
        verticalAlign:strokeAlign||"-0.18em",...style}}
      {...rest}
    />
  );
}
